export enum UtilizacaoBalancasEnum {
  CALCINACAO = 'CALCINACAO',
  FIRE_ASSAY = 'FIRE_ASSAY',
  GRAVIMETRIA = 'GRAVIMETRIA',
  ICP = 'ICP',
  ICP_COBRE = 'ICP_COBRE',
  UMIDADE_BALANCA = 'UMIDADE_BALANCA',
}

export enum BalancasEventsEnum {
  Criada = 'criada',
  Alterada = 'alterada',
  Removida = 'removida',
}
